export const formatAddress = (address: string, postcode: string): string => {
  if (address.slice(-2) === ', ') {
    return `${address.slice(0, -2)} ${postcode}`;
  }

  return `${address} ${postcode}`;
};
